import { node } from 'prop-types';
import React from 'react';

const ModalHeader = ({ children }) => {
	return <div className="common-popup-header d-flex justify-content-between">{children}</div>;
};

ModalHeader.propTypes = {
	children: node.isRequired
};

export default ModalHeader;
